import { v4 as uuid } from "uuid";
import {
  array,
  boolean,
  date,
  number,
  object,
  string,
  ObjectSchema,
} from "yup";

import type { Sex, Horse } from "@/types";

export const horseSchema: ObjectSchema<Horse> = object({
  _id: string()
    .uuid()
    .required()
    .default(() => uuid()),
  _rev: string().optional(),
  _deleted: boolean().optional(),
  type: string().ensure().required().oneOf(["horse"]).default("horse"),
  createdAt: date().optional(),
  updatedAt: date().optional(),
  name: string().label("Name").ensure().required().min(2),
  sex: string<Sex>()
    .label("Sex")
    .ensure()
    .oneOf(["", "gelding", "mare", "stallion"]),
  yearOfBirth: number().label("Year of Birth").positive().integer().optional(),
  color: string().label("Color").ensure(),
  breed: string().label("Breed").ensure(),
  usage: string().label("Usage").ensure(),
  housing: string().label("Housing").ensure(),
  diseases: string().label("Diseases").ensure(),
  notes: string().label("Notes").ensure(),
  clientId: string().label("Client").uuid().optional(),
  stableId: string().label("Stable").uuid().optional(),
  active: boolean().default(true),
  tags: array().of(string().ensure().trim()).label("Tags").default([]),
});
